import { SemanticColorKey } from 'app/components/v2/theme/colors';

export type StatusColor =
  | 'blue'
  | 'green'
  | 'pink'
  | 'red'
  | 'teal'
  | 'violet'
  | 'yellow';

export type SemanticStatusColor = Extract<SemanticColorKey,
  | 'status_blue'
  | 'status_green'
  | 'status_pink'
  | 'status_red'
  | 'status_teal'
  | 'status_violet'
  | 'status_yellow'
>;

export const semanticStatusColorLookup: Record<StatusColor, SemanticStatusColor> = {
  blue: 'status_blue',
  green: 'status_green',
  pink: 'status_pink',
  red: 'status_red',
  teal: 'status_teal',
  violet: 'status_violet',
  yellow: 'status_yellow',
};
